import { CurrencyCodes } from '@monetize/types/common';
import { MdAdd } from 'react-icons/md';
import { useCreateOrUpdateCurrencySettings } from '../../../../api/settingsService';
import { MBox, MButton, MFlex, MText } from '../../../../components/Monetize';
import {
  getCurrencyName,
  getCurrencySample,
} from '../utils/currencySettings.utils';

interface AvailableCurrencyTileProps {
  code: CurrencyCodes;
  isHidden: boolean;
}

export const AvailableCurrencyTile = ({
  code,
  isHidden,
}: AvailableCurrencyTileProps) => {
  const name = getCurrencyName(code);
  const { mutate: doEnable, isPending } = useCreateOrUpdateCurrencySettings({
    meta: { showErrorToast: true },
  });

  return (
    <MFlex
      data-testid={`currency-available-${code}`}
      display={isHidden ? 'none' : 'flex'}
      align="center"
      gap={3}
      pl={4}
      pr={2}
      py={2}
      borderWidth="1px"
      borderStyle="solid"
      borderColor="border.subtle"
      borderRadius="md"
      bg="bg.surface"
    >
      <MBox flex={1} minW={0}>
        <MFlex align="baseline" gap={2} minW={0}>
          <MText fontWeight="semibold" color="fg.strong" flexShrink={0}>
            {code}
          </MText>
          <MText truncate color="fg.primary" title={name}>
            {name}
          </MText>
        </MFlex>
        <MText
          fontSize="xs"
          color="fg.muted"
          css={{ fontVariantNumeric: 'tabular-nums' }}
        >
          {getCurrencySample(code)}
        </MText>
      </MBox>
      <MButton
        data-testid={`currency-enable-${code}`}
        aria-label={`Enable ${code}`}
        variant="tertiary"
        size="sm"
        flexShrink={0}
        leftIcon={<MdAdd />}
        isLoading={isPending}
        onClick={() =>
          doEnable({
            action: 'create',
            payload: { code, defaultCurrency: false, description: name },
          })
        }
      >
        Enable
      </MButton>
    </MFlex>
  );
};
